import { logout, unregisterNotifications } from "@app/utils/firebase";
import { playerContext } from "@layouts/App/context/Player";
import { useNavigate } from "@solidjs/router";
import { batch, useContext } from "solid-js";
const useSignOut = () => {
	const navigate = useNavigate();
	const { setPlayer } = useContext(playerContext);

	const signOut = async () => {
		try {
			await unregisterNotifications();
		} catch {
			/* empty */
		}
		batch(() => {
			setPlayer("queue", []);
			setPlayer("track", -1);
			setPlayer("time", 0);
			setPlayer("playing", false);
			setPlayer("disabled", true);
		});

		return logout().then(() => {
			navigate("/auth/login");
		});
	};
	return signOut;
};
export default useSignOut;
